module.exports = __webpack_public_path__ + "public/images/cooking-baking.503605a523c8c844f12a1688c6654240.jpg";